/** Web clients opt out of automatic "On the Way" SMS; mobile app omits this flag (backend default: send). */
export const WEB_APPOINTMENT_STATUS_SMS_PAYLOAD = {
  sendOnTheWaySms: false,
} as const;
